const UNIT_BY_SPECIFICATION: Record<string, string> = {
  fueltankcapacity: "L",
  cngfueltankcapacity: "kg",
  minimumturningradius: "m",
  reartrack: "mm",
  fronttrack: "mm",
  groundclearance: "mm",
  wheelbase: "mm",
  height: "mm",
  width: "mm",
  length: "mm",
  dimension: "mm",
  bootspacewithfoldableseats: "L",
  bootspace: "L",
  grossvehicleweight: "kg",
  kerbweight: "kg",
  maxtorque: "Nm",
  maxpower: "bhp",
  displacement: "cc",
  batterycapacity: "kWh",
  araimileage: "kmpl",
  range: "km",
  araimileagecng: "km/kg",
  topspeed: "kmph",
  "0100kmph": "s",
};

const UNIT_PATTERNS: Record<string, RegExp> = {
  L: /\b(?:l|litres?|liters?)\b/i,
  kg: /\b(?:kg|kilograms?)\b/i,
  m: /\b(?:m|metres?|meters?)\b/i,
  mm: /\b(?:mm|millimet(?:er|re)s?)\b/i,
  Nm: /\b(?:nm|newton[ -]?met(?:er|re)s?)\b/i,
  bhp: /\b(?:bhp|horsepower)\b/i,
  cc: /\b(?:cc|cubic centimet(?:er|re)s?)\b/i,
  kWh: /\b(?:kwh|kilowatt[ -]?hours?)\b/i,
  kmpl: /\b(?:kmpl|km\s*\/\s*l|km\s*per\s*lit(?:re|er))\b/i,
  km: /\b(?:km|kilomet(?:er|re)s?)\b/i,
  "km/kg":
    /\b(?:km\s*\/\s*kg|km\s*per\s*kg|kilomet(?:er|re)s?\s*per\s*kilograms?)\b/i,
  kmph: /\b(?:kmph|km\s*\/\s*h|km\s*per\s*hour)\b/i,
  s: /\b(?:s|sec|secs|seconds?)\b/i,
};

const normalizeSpecificationName = (name: string): string =>
  name.toLowerCase().replace(/[^a-z0-9]/g, "");

const isNumericLike = (value: string): boolean =>
  /\d/.test(value) && /^[\d\s,.+\-/×x]+$/i.test(value);

/** Adds the display unit for ticketed numeric specs without changing API data. */
export const formatSpecificationValue = (
  specificationName: string,
  value?: string | number | null
): string | undefined => {
  if (value === undefined || value === null) return undefined;

  const displayValue = String(value).trim();
  if (
    !displayValue ||
    displayValue === "-" ||
    displayValue === "Not Applicable"
  ) {
    return displayValue || undefined;
  }

  const unit =
    UNIT_BY_SPECIFICATION[normalizeSpecificationName(specificationName)];
  if (!unit) return displayValue;
  if (UNIT_PATTERNS[unit]?.test(displayValue)) return displayValue;
  if (!isNumericLike(displayValue)) return displayValue;

  return `${displayValue} ${unit}`;
};
